import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, ClipboardCheck, Code, FileText, Globe, Home, Layers, Lock, LogIn, Menu, Network, Presentation, Sparkles, X } from 'lucide-react';
import { beginCustomerLogin } from '../services/customerAuthService';
import { useNavigationIdentity } from '../hooks/useNavigationIdentity';

const customerItems = [
  { label: 'Home', icon: Home, path: '/' },
  { label: 'Free Preview Workspace', icon: Code, path: '/free' },
  { label: 'DIY Compiler', icon: BookOpen, path: '/diy' },
  { label: 'Advanced Compiler', icon: Lock, path: '/advanced-compiler' },
  { label: 'Sample Gallery', icon: BookOpen, path: '/sample-gallery' },
  { label: 'Plans', icon: Sparkles, path: '/pricing' },
];

const adminItems = [
  ...customerItems,
  { label: 'Comparison Checklist', icon: ClipboardCheck, path: '/checklist' },
  { label: 'Interactive Story DIY', icon: BookOpen, path: '/examples' },
  { label: 'PRO Features', icon: Sparkles, path: '/pro' },
  { label: 'Agency Suite', icon: Globe, path: '/agency' },
  { label: 'Twee Compiler (Legacy)', icon: Code, path: '/compiler' },
  { label: 'Visual Story Planner', icon: Layers, path: '/visual-story-planner' },
  { label: 'Visual Editor', icon: Network, path: '/visual-editor' },
  { label: 'Visual Form Editor', icon: FileText, path: '/visual-form-editor' },
  { label: 'LinkedIn Compiler', icon: Presentation, path: '/linkedin-slide-compiler' },
  { label: 'Home2', icon: Home, path: '/home2' },
  { label: 'Old Homepage', icon: Home, path: '/old-homepage' },
  { label: 'Sheret', icon: Layers, path: '/sheret' },
];

const HamburgerMenu = ({ workspaceMode = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const identity = useNavigationIdentity();
  const menuItems = identity.role === 'admin' ? adminItems : customerItems;

  const navigateTo = (path) => { navigate(path); setIsOpen(false); };
  const accountLabel = identity.role === 'admin' ? 'Administrator' : identity.role === 'diy' ? 'DIY account' : identity.role === 'free' ? 'Free account' : 'Sign in';

  return <div className={workspaceMode ? 'relative z-50' : 'absolute top-4 right-4 z-50'}>
    <button type="button" onClick={() => setIsOpen(!isOpen)} data-testid="hamburger-menu-toggle" className="rounded-md bg-white/90 p-2 shadow-md transition-colors hover:bg-slate-100" aria-label="Menu">
      {isOpen ? <X className="h-6 w-6 text-slate-700" /> : <Menu className="h-6 w-6 text-slate-700" />}
    </button>
    {isOpen && <><div className="fixed inset-0 z-40" data-testid="hamburger-menu-backdrop" onClick={() => setIsOpen(false)} />
      <div className="absolute right-0 z-50 mt-2 w-64 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg" data-testid="hamburger-menu-panel">
        {menuItems.map((item) => { const Icon = item.icon; const active = location.pathname === item.path; return <button key={item.path} type="button" data-testid={`hamburger-menu-item-${item.path.replaceAll('/', '-') || 'home'}`} onClick={() => navigateTo(item.path)} className={`flex w-full items-center px-4 py-3 text-left transition-colors ${active ? 'bg-indigo-50 font-semibold text-indigo-700' : 'text-slate-700 hover:bg-slate-50'}`}><Icon className="h-4 w-4" /><span className="ml-3 text-sm font-medium">{item.label}</span></button>; })}
        <div className="border-t border-slate-100 p-3" data-testid="hamburger-account-state">
          {identity.status === 'loading' ? <span className="text-xs text-slate-500">Checking account…</span> : identity.role === 'visitor' ? <button type="button" onClick={beginCustomerLogin} data-testid="hamburger-login-button" className="flex w-full items-center justify-center gap-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-700"><LogIn className="h-4 w-4" />Continue with Google</button> : <p className="text-xs font-medium text-slate-600" data-testid="hamburger-account-label">{accountLabel}{identity.user?.name ? ` · ${identity.user.name}` : ''}</p>}
        </div>
      </div></>}
  </div>;
};

export default HamburgerMenu;